/* Pocket Factory: the Google business behind the website typed for the card (PLACE-MATCH-1; Bryton, Oct 29).
   Where: step 02's Website link only ("Use a different link", snippets/pocket-purpose-details.liquid: the order box's
   "Where should a tap go?" panel, or the product page's own step 02). Never the hero (Theo's review, Oct 29): not its
   box or lookup (assets/pocket-composer.js: not good enough yet, Bryton), not question 2's link; nor step 01's business
   field or the Buy guide's.
   - A website typed there (their own site's home page: never a page under a path, a social, review, booking or link
     page, nor Google's) is asked of the Worker's GET /api/review-link?q=<bare domain>
     (worker/pocketfactory-brand/src/review-link-route.js: Places Text Search, matched by the place's website, chains
     refused) 600 ms after the last keystroke. One request at a time; each domain's answer is kept in this tab
     (sessionStorage), so a domain is asked once.
   - Exactly one match that is not a chain, with its Google review form: the card becomes a Google review card with that
     form as its tap link (the Buy gate takes it as the card's link), and a line says "Found <name> on Google" with
     "Not you?", which puts the card back on their website. The switch waits until they leave the field, so the field
     they are typing in never goes away under them, and never comes while a Buy is being pressed.
     On a product page of one fixed card type (the website, booking, social or contact card's; a niche page's own card
     type that is not a review card), the card stays as it is and a chip offers the Google review card instead: "We
     found <name> on Google. Make it a Google reviews card?", a link to the Google review card's page as the review link
     tool hands over (?focus=reviews&business=&review_link=&review_address=, no ?variant=; read there by
     assets/pocket-review-match.js). There, the card this tab's design is saved at opens again as it was
     (pocket-card-profile.js: their website card, over the address's link), so once it has opened, the link they tapped
     for goes on it (arrived()).
   - No match, a chain, an error, a 429 (the Worker's 20 searches an IP in 10 minutes; nothing more is asked until its
     Retry-After), a 502 or no answer within 2.5 s: nothing shows and the card stays their website's.
   - Through each part's own hook, feature-detected, so the same file runs on an older theme line: the card's type is
     changed by its owner, question 2's answer (PocketCardProfile.page.answer), where the hero's questions are on the
     page, so they and step 02 agree; else by step 02's own controls (PocketPurpose, the review site, the review link
     field). A saved card applied (pocket:card-profile-applied), or the
     card's type or link changed by anyone else, takes the line off; it never puts anything back.
   - The business found is handed to the review card's own business field (pocket-review-match.js's tab key,
     pf.reviewMatch.v1), so it names it without asking Google again. While the line shows, that field steps aside in the
     same box (data-pf-place-matched): one "Not you?" for one business, never two; it is back as the line goes.
   Analytics: pf_place_match {result: matched | none | chain | error | undo} through PocketAnalytics (allow-listed in
   assets/pocket-analytics.js). Never what was typed or found. */
(function (root) {
  'use strict';
  if (typeof document === 'undefined' || root.PocketPlaceMatch) return;
  const win = root, doc = document;
  // A pause in typing (as pocket-review-match.js: each search counts against the Worker's 20 an IP in 10 minutes).
  const DEBOUNCE_MS = 600;
  // An answer later than this is no answer.
  const TIMEOUT_MS = 2500;
  // A Buy pressed this recently: the card is never switched under it.
  const BUY_HOLD_MS = 2000;
  const MOTION_MS = 220;
  // The chip tapped this recently, for the page it opens; that page's saved card waited for this long.
  const ARRIVE_MS = 120000;
  const OPENING_MS = 20000;
  // This tab's answers by domain, the domains they said "Not you?" to, a 429's pause and the chip tapped (go).
  const STORE = 'pf.placeMatch.v1';
  // pocket-review-match.js's tab key: the business on the card, with its link, named without a search.
  const KEPT = 'pf.reviewMatch.v1';
  const MAX_KEPT = 30;
  const REVIEW_FORM = /^https:\/\/search\.google\.com\/local\/writereview\?placeid=([A-Za-z0-9_-]{10,200})$/;
  // Product listings of one card type. The Google review card's and the NFC card's switch freely.
  const FIXED = new Set(['website-nfc-card', 'booking-nfc-card', 'social-media-nfc-card', 'contact-nfc-card']);
  const REVIEW_PRODUCT = 'products/google-review-nfc-card';
  // Question 2's link box: read (the card's link there), never listened to.
  const Q2_LINK = '[data-pfq-link]';
  const STEP_LINK = '[name="properties[Website destination]"]';
  const BUY = '[data-purchase],[data-pfx-buy],[data-pf-buy-now],[data-add],[data-pay-area]';
  // Hosts that are never a business's own site (where PocketBrandService.linkPurpose isn't loaded to say so).
  const NOT_THEIRS = /(?:^|\.)(?:google\.[a-z.]+|g\.page|goo\.gl|g\.co|share\.google|getpocketfactory\.com|facebook\.com|fb\.com|instagram\.com|tiktok\.com|x\.com|twitter\.com|linkedin\.com|youtube\.com|yelp\.com|tripadvisor\.com|trustpilot\.com|linktr\.ee)$/;
  const HOST = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,24}|xn--[a-z0-9-]{2,59})$/;

  const form = () => doc.querySelector('[data-pocket-product] form.product-form');
  const base = () => String(win.PocketCore?.workerBase?.() || '').replace(/\/+$/, '');
  const q2Choice = () => doc.querySelector('[data-pfq-choice]:checked')?.value || '';
  // The card's type is PocketPurpose's to read (assets/pocket-purpose.js); without it, step 02 is left alone.
  const purpose = () => win.PocketPurpose?.get?.() || '';
  const reviewField = () => form()?.querySelector('[data-rv-review-link]') || null;
  const reduced = () => !!win.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  // On the page and drawn: no hidden ancestor, no display:none or visibility:hidden on it or above it, and not folded in
  // a closed <details> (only its summary shows; its own style never says so).
  function shown(node) {
    if (!node?.isConnected || node.closest('[hidden]')) return false;
    for (let at = node; at && at.nodeType === 1; at = at.parentElement) {
      const look = win.getComputedStyle(at);
      if (look.display === 'none' || look.visibility === 'hidden') return false;
      if (at !== node && at.localName === 'details' && !at.open && node.closest('summary')?.parentElement !== at) return false;
    }
    return true;
  }
  const track = result => { try { win.PocketAnalytics?.capture?.('pf_place_match', { result }); } catch (_) {} };
  const fire = (node, type) => node.dispatchEvent(new win.Event(type, { bubbles: true }));

  /** The bare domain of a site's home page typed ("https://www.joespizza.com/" is "joespizza.com"), or '' for anything
      else: spaces, a user or a port, no dotted name, an IP, a platform's page (any host PocketBrandService.linkPurpose
      names: social, review, booking, link-in-bio, marketplace, short link, Google; NOT_THEIRS where it isn't loaded), or
      a page under a path. A path's page may be a platform's page for the business (tidycal.com/joe,
      order.chownow.com/order/…): Google is asked for its host, and would find the platform. */
  function domainOf(raw) {
    const text = String(raw || '').trim();
    if (!text || text.length > 2048 || /\s/.test(text)) return '';
    let url;
    try { url = new URL(/^[a-z][a-z\d+.-]*:/i.test(text) ? text : `https://${text}`); } catch (_) { return ''; }
    if (!/^https?:$/.test(url.protocol) || url.username || url.password || url.port || url.pathname !== '/') return '';
    const host = url.hostname.toLowerCase().replace(/\.$/, '').replace(/^www\./, '');
    if (!HOST.test(host) || NOT_THEIRS.test(host)) return '';
    let platform = null;
    try { platform = win.PocketBrandService?.linkPurpose?.(url.href) || null; } catch (_) {}
    return platform ? '' : host;
  }
  /** The website as typed, as a whole address (for "Not you?", which puts it back). */
  function siteOf(raw) {
    const text = String(raw || '').trim();
    try { return new URL(/^[a-z][a-z\d+.-]*:/i.test(text) ? text : `https://${text}`).href; } catch (_) { return text; }
  }
  // Step 02's Website link, the only field this listens to (question 2's link is the hero's: never).
  const ours = field => !!field?.matches?.(STEP_LINK) && !!form()?.contains(field);
  /** The field is the card's website link now: step 02's, while it is a Website card. */
  const websiteField = field => ours(field) && purpose() === 'Website' && !field.disabled && !field.closest('fieldset[disabled]');
  /** A page of one card type: its listing's (FIXED), or a niche page's preset that is not the review card. */
  function fixedType() {
    const handle = doc.querySelector('[data-listing-handle]')?.dataset.listingHandle || '';
    if (handle) return FIXED.has(handle);
    let preset = '';
    try { preset = JSON.parse(doc.querySelector('script[type="application/json"][data-pf-niche-preset]')?.textContent || '{}')?.purpose || ''; } catch (_) {}
    return !!preset && preset !== 'Reviews';
  }

  /* ---------- This tab's answers ---------- */
  function load() {
    try {
      const saved = JSON.parse(win.sessionStorage.getItem(STORE) || 'null');
      if (saved && saved.v === 1 && saved.d && typeof saved.d === 'object' && Array.isArray(saved.no)) return saved;
    } catch (_) {}
    return { v: 1, d: {}, no: [], pause: 0 };
  }
  const saved = load();
  function save() { try { win.sessionStorage.setItem(STORE, JSON.stringify(saved)); } catch (_) {} }
  function remember(domain, answer) {
    saved.d[domain] = { ...answer, t: Date.now() };
    const keys = Object.keys(saved.d);
    if (keys.length > MAX_KEPT) for (const key of keys.sort((a, b) => saved.d[a].t - saved.d[b].t).slice(0, keys.length - MAX_KEPT)) delete saved.d[key];
    save();
  }
  const declined = domain => saved.no.includes(domain);
  function decline(domain) { if (!declined(domain)) { saved.no = [...saved.no, domain].slice(-MAX_KEPT); save(); } }

  /* ---------- The Worker's answer ---------- */
  const state = { off: false, timer: 0, pending: null, waiting: null, inflight: null, active: null, chip: null, buyAt: 0, typed: new WeakSet(), slots: new WeakMap(), status: null };

  /** The answer as this script takes it: matched (with the place's name, review form and address), none or chain. */
  function read(body) {
    if (body.chain === true) return { result: 'chain' };
    const match = typeof body.match === 'string' ? body.results.find(result => result && result.placeId === body.match) : null;
    const id = REVIEW_FORM.exec(String(match?.writereviewUrl || ''))?.[1] || '';
    const name = typeof match?.name === 'string' ? match.name.replace(/\s+/g, ' ').trim().slice(0, 120) : '';
    // A website's match is made by its website; any other sureness (a name read from it) is not theirs for sure.
    if (!match || !id || id !== match.placeId || !name || (body.kind && body.kind !== 'website') || (body.matchedBy && body.matchedBy !== 'website')) return { result: 'none' };
    const address = String(match.formattedAddress || match.city || '').replace(/\s+/g, ' ').trim().slice(0, 200);
    return { result: 'matched', name, url: match.writereviewUrl, address };
  }
  /** The answer for a domain: kept, or asked (one request at a time; an older one still on its way is let go). null when
      there is none to have: an error, a 429, no answer in time, or the finder off. quiet: asked for the card designer's
      box (SP-1), which sends its own event, so pf_place_match stays step 02's. */
  function ask(domain, quiet = false) {
    if (saved.d[domain]) return Promise.resolve(saved.d[domain]);
    const worker = base();
    if (state.off || !worker || Date.now() < saved.pause) return Promise.resolve(null);
    if (state.inflight?.domain === domain) return state.inflight.promise;
    if (state.inflight) { state.inflight.controller.superseded = true; state.inflight.controller.abort(); }
    const controller = new win.AbortController();
    const promise = (async () => {
      const timer = win.setTimeout(() => controller.abort(), TIMEOUT_MS);
      try {
        const response = await win.fetch(`${worker}/api/review-link?q=${encodeURIComponent(domain)}`, { headers: { Accept: 'application/json' }, credentials: 'omit', signal: controller.signal });
        const body = await response.json().catch(() => null);
        if (response.ok && body && Array.isArray(body.results)) {
          const answer = read(body);
          remember(domain, answer);
          if (answer.result !== 'matched' && !quiet) track(answer.result);
          return answer;
        }
        // Too many searches: nothing more is asked until its Retry-After. No finder on this Worker: none on this page.
        if (response.status === 429) { saved.pause = Date.now() + Math.max(1, Number(body?.retryAfter) || Number(response.headers?.get?.('Retry-After')) || 60) * 1000; save(); }
        else if (response.status === 404 || response.status === 503) state.off = true;
      } catch (_) {
        // A newer domain took over: that one says how it went.
        if (controller.superseded) return null;
      } finally {
        win.clearTimeout(timer);
        if (state.inflight?.controller === controller) state.inflight = null;
      }
      if (!quiet) track('error');
      return null;
    })();
    state.inflight = { domain, controller, promise };
    return promise;
  }

  /* ---------- What shows ---------- */
  function style() {
    if (doc.getElementById('pf-place-match-style')) return;
    const css = doc.createElement('style');
    css.id = 'pf-place-match-style';
    // Opened and closed by its height (a one-row grid from 0fr to 1fr), so nothing under it jumps. The chip has step 02's
    // own control look (its "Use a different link"); the line the theme's lime start border.
    css.textContent = '.pf-pm{display:grid;grid-template-rows:0fr;opacity:0;transition:grid-template-rows .22s ease,opacity .22s ease}' +
      '.pf-pm[data-open]{grid-template-rows:1fr;opacity:1}.pf-pm[hidden]{display:none}.pf-pm__in{min-height:0;overflow:hidden}' +
      '.pf-pm__line{display:flex;flex-wrap:wrap;align-items:center;gap:0 10px;margin:12px 0 16px;padding-block:2px;padding-inline:12px 0;border-inline-start:3px solid var(--pfx-lime,#d6f753);color:var(--pfx-ink,#15170f);font:500 14px/1.4 var(--pfx-font,inherit)}' +
      '.pf-pm__said{flex:1 1 12rem;min-width:0;overflow-wrap:anywhere}.pf-pm strong{font-weight:800}' +
      '.pf-pm__undo{flex:none;display:inline-flex;align-items:center;min-width:44px;min-height:44px;margin:0;padding:0 4px;border:0;background:none;color:inherit;font:700 13px/1.2 var(--pfx-font,inherit);text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
      '.pf-pm__go{display:flex;align-items:center;gap:12px;box-sizing:border-box;width:100%;min-height:59px;margin:12px 0 2px;padding:10px 15px;border:2px solid var(--pfx-line,#b9b9b3);background:#fff;color:var(--pfx-ink,#15170f);font:500 14px/1.4 var(--pfx-font,inherit);text-align:start;text-decoration:none}' +
      '.pf-pm__go>span{flex:1 1 auto;min-width:0;overflow-wrap:anywhere}.pf-pm__go::after{content:"\\2192";content:"\\2192"/"";flex:none;font-weight:700}' +
      '[dir="rtl"] .pf-pm__go::after{transform:scaleX(-1)}' +
      '.pf-pm__undo:focus-visible,.pf-pm__go:focus-visible{outline:2px solid var(--pfx-ink,#15170f);outline-offset:2px}' +
      '.pf-pm-vh{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0}' +
      '[data-pf-place-matched] [data-review-match]{display:none!important}' +
      '@media (prefers-reduced-motion:reduce){.pf-pm{transition:none}}';
    doc.head.appendChild(css);
  }
  // One voice for this script, polite, on the page before it speaks (so its first words are read out).
  function voice() {
    if (state.status?.isConnected) return state.status;
    const status = doc.createElement('p');
    status.className = 'pf-pm-vh';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.dataset.pfPlaceMatchStatus = '';
    doc.body.appendChild(status);
    return (state.status = status);
  }
  function say(text) {
    const status = voice();
    if (status.textContent === text) status.textContent = '';
    win.setTimeout(() => { status.textContent = text; }, 50);
  }
  /** The place a line or the chip goes, made once: the line at the top of step 02's card types' fields (it stays when
      the Website field goes), the chip under the Website link. */
  function slotFor(field, kind) {
    let anchor = null, where = 'after';
    if (kind === 'line') { anchor = field.closest('.purpose-details'); where = 'prepend'; }
    else { anchor = field.closest('details'); where = 'append'; }
    if (!anchor) { anchor = field.closest('label') || field; where = 'after'; }
    const key = `${where}:${kind}`;
    const known = state.slots.get(anchor)?.[key];
    if (known?.isConnected) return known;
    style();
    const slot = doc.createElement('div');
    slot.className = 'pf-pm';
    slot.hidden = true;
    slot.dataset.pfPlaceMatch = kind;
    const inner = doc.createElement('div');
    inner.className = 'pf-pm__in';
    slot.append(inner);
    if (where === 'prepend') anchor.prepend(slot); else if (where === 'append') anchor.append(slot); else anchor.after(slot);
    state.slots.set(anchor, { ...(state.slots.get(anchor) || {}), [key]: slot });
    return slot;
  }
  // A slot is wanted open or not (want), whatever frame or timer of its last change is still to come.
  function open(slot, content) {
    slot.firstElementChild.replaceChildren(content);
    slot.want = true;
    win.clearTimeout(slot.closing);
    slot.hidden = false;
    if (reduced() || !win.requestAnimationFrame) { slot.dataset.open = ''; return; }
    void slot.offsetHeight;
    win.requestAnimationFrame(() => { if (slot.want) slot.dataset.open = ''; });
  }
  function close(slot) {
    if (!slot || slot.hidden) return;
    slot.want = false;
    delete slot.dataset.open;
    win.clearTimeout(slot.closing);
    const done = () => { if (!slot.want) { slot.hidden = true; slot.firstElementChild.replaceChildren(); } };
    if (reduced()) done(); else slot.closing = win.setTimeout(done, MOTION_MS);
  }
  /** "Found <name> on Google" and "Not you?". */
  function lineOf(name) {
    // Its words in a span: step 02's own paragraph style (.purpose-details p) is for its notes, not this line.
    const box = doc.createElement('div'), said = doc.createElement('span'), strong = doc.createElement('strong'), undo = doc.createElement('button'), more = doc.createElement('span');
    box.className = 'pf-pm__line';
    said.className = 'pf-pm__said';
    strong.textContent = name;
    said.append('Found ', strong, ' on Google');
    undo.type = 'button';
    undo.className = 'pf-pm__undo';
    undo.dataset.pfPlaceMatchUndo = '';
    more.className = 'pf-pm-vh';
    more.textContent = ' Use my website on this card instead';
    undo.append('Not you?', more);
    undo.addEventListener('click', notYou);
    box.append(said, undo);
    return box;
  }
  /** "We found <name> on Google. Make it a Google reviews card?": to the Google review card's page, its link on it. */
  function chipOf(found) {
    // A link: it goes to another page (and opens in a new tab like any link).
    const go = doc.createElement('a'), words = doc.createElement('span'), strong = doc.createElement('strong');
    go.className = 'pf-pm__go';
    go.href = reviewCardHref(found);
    go.dataset.pfPlaceMatchGo = '';
    strong.textContent = found.name;
    words.append('We found ', strong, ' on Google. Make it a Google reviews card?');
    go.append(words);
    go.addEventListener('click', () => going(found));
    return go;
  }
  // A tap on a chip for the Google review card's page: for the page it opens in this tab (arrived()).
  function going(found) { saved.go = { url: found.url, at: Date.now() }; save(); }
  /** The Google review card's page as a review card, with the business and its review form, as the review link tool
      hands it over (sections/pf-review-link-generator.liquid, assets/pf-review-link-generator.js): ?focus=reviews,
      then business, review_link and review_address. Its own default pack: never ?variant=. */
  function reviewCardHref(found) {
    const home = String(doc.body?.dataset.root || '/').replace(/\/?$/, '/');
    const url = new URL(home + REVIEW_PRODUCT, win.location.href);
    url.searchParams.set('focus', 'reviews');
    url.searchParams.set('business', found.name.slice(0, 80));
    url.searchParams.set('review_link', found.url);
    if (found.address) url.searchParams.set('review_address', found.address.slice(0, 200));
    return url.pathname + url.search;
  }

  /* ---------- The card ---------- */
  /** The business found, handed to the review card's own business field, so it names it without a search. */
  function hand(found) { try { win.sessionStorage.setItem(KEPT, JSON.stringify({ url: found.url, name: found.name, address: found.address })); } catch (_) {} }
  function unhand(url) { try { if (JSON.parse(win.sessionStorage.getItem(KEPT) || 'null')?.url === url) win.sessionStorage.removeItem(KEPT); } catch (_) {} }
  /** The card made a Google review card with url as its link: through question 2 where it is on the page (its answer;
      step 02 follows), else step 02's own controls (as pocket-review-match.js puts a link on). How, or '' when it didn't
      take. */
  function toReviews(url, site) {
    const page = win.PocketCardProfile?.page;
    if (typeof page?.answer === 'function' && doc.querySelector('[data-pfq-choice]')) {
      const was = q2Choice();
      if (!page.answer('reviews', url, { quiet: true }) && q2Choice() === 'reviews') return 'q2';
      // Refused (its review site is another one): question 2 goes back to their website, as it was.
      if (site && was === 'website' && q2Choice() !== 'website') page.answer('website', site, { quiet: true });
      return '';
    }
    const scope = form(), link = reviewField();
    if (!scope || !link || typeof win.PocketPurpose?.set !== 'function') return '';
    const google = [...scope.querySelectorAll('[name="properties[Review platform]"]')].find(radio => radio.value === 'Google');
    if (google && !google.checked) { google.checked = true; fire(google, 'change'); }
    // The card type first (its review fields come on), then its link, in the same task: the review card's field finds
    // the link there when it looks.
    if (!win.PocketPurpose.set('Reviews')) return '';
    link.value = url;
    fire(link, 'input');
    fire(link, 'change');
    return purpose() === 'Reviews' && link.value === url ? 'step' : '';
  }
  /** Back on their website: question 2's answer, or step 02's card type (its Website link was never changed). */
  function toWebsite(active) {
    const page = win.PocketCardProfile?.page;
    if (active.via === 'q2' && typeof page?.answer === 'function') { page.answer('website', active.site, { quiet: true }); return; }
    win.PocketPurpose?.set?.('Website');
    const link = reviewField();
    if (link && link.value.trim() === active.url) { link.value = ''; fire(link, 'input'); fire(link, 'change'); }
  }
  // The review site may be another one they chose (Yelp, Trustpilot): never moved to Google by itself.
  const elsewhere = () => { const site = form()?.querySelector('[name="properties[Review platform]"]:checked')?.value; return !!site && site !== 'Google'; };

  function apply(field, domain, found) {
    if (Date.now() - state.buyAt < BUY_HOLD_MS || declined(domain) || elsewhere() || !websiteField(field) || domainOf(field.value) !== domain) return;
    const site = siteOf(field.value);
    hand(found);
    const via = toReviews(found.url, site);
    if (!via) { unhand(found.url); return; }
    dropChip();
    const slot = slotFor(field, 'line'), box = boxOf(field);
    state.active = { field, domain, url: found.url, name: found.name, site, via, slot, box };
    box?.setAttribute('data-pf-place-matched', '');
    open(slot, lineOf(found.name));
    say(`Found ${found.name} on Google. Its review link is on your card.`);
    track('matched');
  }
  function offer(field, domain, found) {
    if (state.chip?.domain === domain && state.chip.field === field && !state.chip.slot.hidden) return;
    dropChip();
    const slot = slotFor(field, 'chip');
    state.chip = { field, domain, slot };
    open(slot, chipOf(found));
    say(`We found ${found.name} on Google. Make it a Google reviews card?`);
    track('matched');
  }
  function dropChip() { if (state.chip) { close(state.chip.slot); state.chip = null; } }
  // The review card's own business field in the line's box: step 02's review link.
  const boxOf = field => field.closest('.purpose-details')?.querySelector('[data-rv-review-link-wrap]') || null;
  function release(active) { active?.box?.removeAttribute('data-pf-place-matched'); }
  function drop() { if (state.active) { release(state.active); close(state.active.slot); state.active = null; } }

  /** "Not you?": the card back on their website, focus back in the field they typed it in, and that site never matched
      again in this tab. */
  function notYou() {
    const active = state.active;
    if (!active) return;
    state.active = null;
    decline(active.domain);
    unhand(active.url);
    release(active);
    toWebsite(active);
    close(active.slot);
    say('');
    track('undo');
    // After the page's own repaint of step 02 (its Website fields come back): the field, or "Use a different link" when
    // their website needs no link of its own (pocket-card-profile.js folds it), else the panel's heading.
    const field = active.field, fold = field.closest('details');
    win.setTimeout(() => {
      const to = [field, fold?.querySelector('summary'), field.closest('[data-rv-editor-panel]')?.querySelector('[data-rv-panel-heading]')].find(node => node && !node.disabled && shown(node));
      to?.focus({ preventScroll: true });
    }, 0);
  }

  /* ---------- Typing ---------- */
  async function look(field, domain) {
    state.pending = null;
    const found = await ask(domain);
    if (!found || found.result !== 'matched') return;
    // Still this field's website, still the card's website link, and not one they said no to.
    if (!field.isConnected || domainOf(field.value) !== domain || !websiteField(field) || declined(domain)) return;
    if (fixedType()) { offer(field, domain, found); return; }
    // While they are still in the field, the switch waits for them to leave it.
    if (doc.activeElement === field) { state.waiting = { field, domain, found }; return; }
    apply(field, domain, found);
  }
  function typed(field) {
    win.clearTimeout(state.timer);
    state.waiting = null;
    const domain = websiteField(field) ? domainOf(field.value) : '';
    // The chip for another site goes as they type.
    if (state.chip && (state.chip.field !== field || state.chip.domain !== domain)) dropChip();
    if (!domain || state.off) { state.pending = null; return; }
    state.pending = { field, domain };
    state.timer = win.setTimeout(() => look(field, domain), DEBOUNCE_MS);
  }
  // They left the field (or pressed Enter, the form's change): a search still waiting goes now, and a match waiting
  // for this goes on the card. After the field's own handling of the change (the order box takes its link first).
  function left(field) {
    win.setTimeout(() => {
      if (state.pending?.field === field) { win.clearTimeout(state.timer); look(field, state.pending.domain); return; }
      const waiting = state.waiting;
      if (waiting?.field === field && doc.activeElement !== field) { state.waiting = null; apply(field, waiting.domain, waiting.found); }
    }, 0);
  }
  /** url is the card's Google review link: question 2's "Google reviews" with it (its box, or the order box: the answer may
      wait for the hero's lookup to end before the order box takes its link, pocket-card-profile.js), or step 02's review
      card with it. */
  function carries(url, via) {
    const has = node => String(node?.value || '').trim() === url;
    return via === 'q2' ? q2Choice() === 'reviews' && (has(doc.querySelector(Q2_LINK)) || has(reviewField())) : purpose() === 'Reviews' && has(reviewField());
  }
  // The line says what is on the card: the card's type or link changed by anyone else (another answer, the review card's
  // own "Not you? Change", a link typed) takes it off.
  function check() { if (state.active && !carries(state.active.url, state.active.via)) drop(); }
  let checking = false;
  const checkSoon = () => { if (checking) return; checking = true; win.setTimeout(() => { checking = false; check(); }, 0); };

  doc.addEventListener('input', event => {
    const field = event.target;
    if (ours(field) && (event.isTrusted || event.pfChosen)) { state.typed.add(field); voice(); typed(field); }
    checkSoon();
  }, true);
  doc.addEventListener('change', event => {
    if (ours(event.target) && state.typed.has(event.target)) left(event.target);
    checkSoon();
  }, true);
  doc.addEventListener('focusout', event => { if (ours(event.target) && state.typed.has(event.target)) left(event.target); }, true);
  // A Buy pressed (a tap, a click, Enter or Space on it, the form sent): the card is never switched under it.
  const buying = event => { if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return; if (event.type === 'submit' || event.target?.closest?.(BUY)) state.buyAt = Date.now(); };
  for (const type of ['pointerdown', 'mousedown', 'keydown', 'click', 'submit']) doc.addEventListener(type, buying, { capture: true, passive: true });
  doc.addEventListener('touchstart', buying, { capture: true, passive: true });
  // A saved card put on the page: what was found for the card before it is not said over it.
  doc.addEventListener('pocket:card-profile-applied', () => { state.waiting = null; drop(); dropChip(); });
  // A Worker that says it has no finder (no Places key yet): nothing is asked.
  try { Promise.resolve(win.PocketCore?.capabilities?.()).then(capabilities => { if (capabilities?.reviewLink === false) state.off = true; }, () => {}); } catch (_) {}

  /* ---------- The Google review card's page, from the chip ---------- */
  /** The chip tapped on the page before (this tab, its address's ?review_link=): the card this tab's design is saved at
      opens here again as it was (pocket-card-profile.js, while the page's loader is up), over the link the address put on.
      Once it has opened, that link goes on it as they asked: question 2's answer, else step 02's controls. Used once. */
  function arrived() {
    const go = saved.go;
    if (!go) return;
    delete saved.go;
    save();
    let link = '';
    try { link = new win.URLSearchParams(win.location.search).get('review_link') || ''; } catch (_) {}
    if (go.url !== link || !REVIEW_FORM.test(link) || !(Date.now() - go.at < ARRIVE_MS)) return;
    // No saved card opening here: the address's link goes on by itself.
    if (!doc.documentElement.classList.contains('pf-card-loading')) return;
    const settle = () => {
      doc.removeEventListener('pocket:card-profile-applied', settle);
      win.clearTimeout(stop);
      // After the rest of its opening (the other listeners of its event).
      win.setTimeout(() => { if (!carries(link, 'q2') && !carries(link, 'step')) toReviews(link, ''); }, 0);
    };
    doc.addEventListener('pocket:card-profile-applied', settle);
    const stop = win.setTimeout(() => doc.removeEventListener('pocket:card-profile-applied', settle), OPENING_MS);
  }
  arrived();

  // The card designer's one box (SP-1, assets/pf-one-box.js) asks with the same answers, pause and card hooks: the website
  // typed there, the line's "Not you?" (decline), and its chip to the Google review card's page.
  root.PocketPlaceMatch = { domainOf, fixedType, state, ask, toReviews, decline, declined, reviewCardHref, going };
})(typeof window !== 'undefined' ? window : this);
